import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=bef0a89a&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=bef0a89a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef0a89a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bef0a89a')) {
      api.createRecord('bef0a89a', component.options)
    } else {
      api.reload('bef0a89a', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=bef0a89a&scoped=true&", function () {
      api.rerender('bef0a89a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2U2N4Db8m2KFn/JS/comp/Paginate.vue"
export default component.exports